import {
  mdiHomeAnalytics,
  mdiWrenchOutline,
  mdiCoachLamp,
  mdiCctv,
  mdiAccountGroup,
  mdiChartPie,
  mdiCellphone,
  mdiShieldAccount,
  mdiPrinter,
  mdiQrcode,
  mdiCashRegister,
  mdiCashMultiple,
  mdiAccountPlus,
  mdiCurrencyJpy,
} from '@mdi/js'
import waiterSidebarContent from '../waiter/sidebarContent'
import useCurrentData from '@/views/composable/useCurrentData'

export default function sidebarContent() {
  const { currentClub: currentClubRef, userAbilities: userAbilitiesRef } = useCurrentData()
  const currentClub = currentClubRef.value || {}
  const userAbilities = userAbilitiesRef.value || []

  return [
    {
      title: 'HOME',
      icon: mdiHomeAnalytics,
      to: {
        name: 'admin-home',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'Admin',
    },
    {
      subheader: 'POS',
      resource: 'Admin',
      action: 'manage',
    },
    ...waiterSidebarContent(),
    {
      title: '顧客統計',
      icon: mdiChartPie,
      to: {
        name: 'admin-customer-stats',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resources: ['customer', 'customer:stats'],
      action: 'read',
    },
    {
      subheader: 'HR',
      resource: 'Admin',
      action: 'manage',
    },
    (
      userAbilities?.findIndex(a => a.subject === 'eod_closing') >= 0
        ? {
          title: 'マネジメント',
          icon: mdiCoachLamp,
          resource: 'Admin',
          action: 'manage',
          id: 'management-menu',
          children: [
            {
              title: '報酬明細',
              to: {
                name: 'payrolls',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'eod_closing',
              action: 'manage',
            },
            // 給与確定は employee:payroll:confirmation 権限を持つユーザーのみ表示する（権限が無い場合はAPIも403）
            ...(userAbilities?.findIndex(a => a.subject === 'employee:payroll:confirmation') >= 0
              ? [{
                title: '給与確定',
                to: {
                  name: 'payroll-confirmations',
                  params: {
                    club_slug: currentClub?.slug,
                  },
                },
                resource: 'eod_closing',
                action: 'manage',
              }]
              : []),
            {
              title: '経費一覧',
              to: {
                name: 'report-expenses',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resources: ['report', 'report:expenses'],
              action: 'read',
            },
            {
              title: 'ダウンロード',
              to: {
                name: 'report-aggregation-export',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resources: ['report', 'report:aggregation_tsv'],
              action: 'read',
            },
          ],
        } : {
          title: 'マネジメント',
          icon: mdiCoachLamp,
          resource: 'Admin',
          action: 'manage',
          to: {
            name: 'admin-hr-earning-summaries',
            params: {
              club_slug: currentClub?.slug,
            },
          },
        }
    ),
    {
      title: 'システム構築',
      icon: mdiWrenchOutline,
      resource: 'Admin',
      action: 'manage',
      children: [
        {
          title: '基本給',
          resource: 'Admin',
          action: 'manage',
          children: [
            {
              title: '時給',
              to: {
                name: 'admin-wage-hourly-wage',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
          ],
        },
        {
          title: 'バック',
          resource: 'Admin',
          action: 'manage',
          children: [
            {
              title: 'システム',
              to: {
                name: 'admin-rebate-system-systems',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: 'ユニット',
              to: {
                name: 'admin-rebate-system-units',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '要素',
              to: {
                name: 'admin-rebate-system-rebates',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
          ],
        },
        {
          title: '変動給',
          resource: 'Admin',
          action: 'manage',
          children: [
            {
              title: 'システム',
              to: {
                name: 'admin-pay-system-systems',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: 'ユニット',
              to: {
                name: 'admin-pay-system-units',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
          ],
        },
        {
          title: '条件',
          resource: 'Admin',
          action: 'manage',
          children: [
            {
              title: 'ポイント',
              to: {
                name: 'admin-pay-condition-vending-point-conditions',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '売上',
              to: {
                name: 'admin-pay-condition-sales-conditions',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '給率',
              to: {
                name: 'admin-pay-condition-contribution-ratio-conditions',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '販売',
              to: {
                name: 'admin-pay-condition-vending-size-conditions',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '紹介',
              to: {
                name: 'admin-pay-condition-referring-size-conditions',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
            {
              title: '卓フィルタ',
              to: {
                name: 'admin-table-filters',
                params: {
                  club_slug: currentClub?.slug,
                },
              },
              resource: 'Admin',
            },
          ],
        },
        {
          title: 'モニターKPI',
          to: {
            name: 'admin-monitor-kpis',
            params: {
              club_slug: currentClub?.slug,
            },
          },
          resource: 'Admin',
        },
        {
          title: 'オプショングループ',
          to: {
            name: 'admin-vendible-option-groups',
            params: {
              club_slug: currentClub?.slug,
            },
          },
          resource: 'Admin',
        },
      ],
    },
    {
      title: '権限管理',
      icon: mdiShieldAccount,
      to: {
        name: 'admin-permission-groups',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'Admin',
      action: 'manage',
    },
    {
      subheader: 'レポート',
      // 配下は収支明細のみのため、リンクと同じ権限で見出しごと隠す
      resource: 'finance:monthly_pl',
      action: 'read',
    },
    {
      title: '収支明細',
      icon: mdiCurrencyJpy,
      to: {
        name: 'admin-monthly-pl',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      // 明示的な権限付与が必要(adminロールでも既定では非表示)
      resource: 'finance:monthly_pl',
      action: 'read',
    },
    {
      subheader: '現金管理',
      resource: 'Admin',
      action: 'manage',
    },
    {
      title: '現金取引履歴',
      icon: mdiCashMultiple,
      to: {
        name: 'admin-cash-register-transactions',
        params: { club_slug: currentClub?.slug },
      },
      resource: 'Admin',
      action: 'manage',
    },
    {
      title: 'レジ締',
      icon: mdiCashRegister,
      to: {
        name: 'admin-cash-register-closings',
        params: { club_slug: currentClub?.slug },
      },
      resource: 'Admin',
      action: 'manage',
    },
    {
      subheader: '管理',
      resource: 'audit:receipts',
      action: 'read',
    },
    {
      title: 'ログ監視β',
      icon: mdiCctv,
      to: {
        name: 'admin-audits',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'audit:receipts',
      action: 'read',
    },
    // セルフオーダー（self_order_enabled が有効な場合のみ表示）
    ...(currentClub?.selfOrderEnabled ? [{
      title: 'セルフオーダー',
      icon: mdiCellphone,
      to: {
        name: 'admin-self-order-settings',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'Admin',
      action: 'manage',
    }] : []),
    {
      subheader: 'CastApp',
      resource: 'cast_app:punch_qr',
      action: 'read',
    },
    {
      title: '打刻QRコード',
      icon: mdiQrcode,
      to: {
        name: 'admin-cast-app-punch-qr',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'cast_app:punch_qr',
      action: 'read',
    },
    {
      title: 'キャスト招待',
      icon: mdiAccountPlus,
      to: {
        name: 'admin-cast-app-invitations',
        params: {
          club_slug: currentClub?.slug,
        },
      },
      resource: 'cast_app:invitations',
      action: 'manage',
    },
  ]
}
